var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.current_user.user_type == _vm.user_types.REAL)?_c('div',[_c('update-real-user')],1):(_vm.current_user.user_type == _vm.user_types.LEGAL)?_c('div',[_c('update-legal-user')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }